import { get } from 'services/request';
import { ICourse } from '../types/courses';

export default class CoursesSelectModel {
  async get() {
    const courses = await get<ICourse[]>(`courses`);
    return courses.sort((a, b) => a.name.localeCompare(b.name));
  }
}
